import { render } from "./NewClinic.vue?vue&type=template&id=9ca2ba58"
import script from "./NewClinic.vue?vue&type=script&lang=js"
export * from "./NewClinic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__